// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ToXh","col":"styles_col__1N708"};